import { render, staticRenderFns } from "./program-module-subjects-table.vue?vue&type=template&id=f4ff2fd2&scoped=true"
import script from "./program-module-subjects-table.vue?vue&type=script&lang=js"
export * from "./program-module-subjects-table.vue?vue&type=script&lang=js"
import style0 from "./program-module-subjects-table.vue?vue&type=style&index=0&id=f4ff2fd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4ff2fd2",
  null
  
)

export default component.exports